import PropTypes from 'prop-types';
import { UserPlus, Users } from 'lucide-react';
import { Heading, Text, Stack } from '@/components/ui/index.js';
import styles from './SuggestionCard.module.css';

/**
 * SuggestionCard - Displays a suggested person to connect with
 * 
 * @param {Object} suggestion - Suggestion data object
 * @param {function} onAdd - Add friend button click handler
 * @param {boolean} isAdded - Whether the friend request has been sent
 * @param {Object} style - Additional inline styles
 */
export function SuggestionCard({ suggestion, onAdd, isAdded, style }) {
  return (
    <article className={styles.card} style={style}>
      {/* Avatar */}
      <div className={styles.avatarContainer}>
        <div className={styles.avatar}>
          {suggestion.name.charAt(0).toUpperCase()}
        </div>
      </div>

      {/* Info */}
      <div className={styles.info}>
        <Stack direction="column" gap={0} align="center">
          <Heading level={3} size="sm" color="primary" align="center" className={styles.name}>
            {suggestion.name}
          </Heading>
          <Text size="xs" color="secondary" align="center">
            {suggestion.sport}
          </Text>
          <div className={styles.mutualFriends}>
            <Users size={10} strokeWidth={2} />
            <Text size="xs" color="muted">
              {suggestion.mutualFriends} mutual
            </Text>
          </div>
        </Stack>
      </div>

      {/* Add Button */}
      <button 
        className={`${styles.addButton} ${isAdded ? styles.added : ''}`}
        onClick={onAdd}
        disabled={isAdded}
        aria-label={isAdded ? `Friend request sent to ${suggestion.name}` : `Add ${suggestion.name} as friend`}
      >
        {isAdded ? (
          'Sent'
        ) : (
          <>
            <UserPlus size={14} />
            Add
          </>
        )}
      </button>
    </article>
  );
}

SuggestionCard.propTypes = {
  suggestion: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    mutualFriends: PropTypes.number.isRequired,
    sport: PropTypes.string.isRequired,
    avatar: PropTypes.string,
  }).isRequired,
  onAdd: PropTypes.func,
  isAdded: PropTypes.bool,
  style: PropTypes.object,
};

export default SuggestionCard;
